import { ReactElement } from 'react';
import { useState } from 'react';
import { createContext } from 'react';

import { getImpressionWorker } from '@/common/impressions/impressionWorker';

interface ImpressionContextProviderProps<Message> {
  children: ReactElement;
  callback: (impressionMessage: Message[]) => void;
  shouldSendSeparately?: boolean;
}

const ImpressionContext = createContext<Worker | null>(null);

const ImpressionsContextProvider = <Message,>({
  children,
  callback,
  shouldSendSeparately,
}: ImpressionContextProviderProps<Message>) => {
  const [impressionWorker, setImpressionWorker] = useState<Worker | null>(null);

  if (typeof Worker !== 'undefined' && !impressionWorker) {
    const worker = getImpressionWorker();
    worker.onmessage = (event): void => {
      const { data } = event;
      if (shouldSendSeparately) {
        data.forEach((message: Message[]) => {
          callback(message);
        });
      } else {
        callback(data);
      }
    };
    worker.onerror = (event) => {
      console.error('impressionWorker have failed', event);
    };

    setImpressionWorker(worker);
  }

  return (
    <ImpressionContext.Provider value={impressionWorker}>{children}</ImpressionContext.Provider>
  );
};

export { ImpressionContext, ImpressionsContextProvider };
